module.exports = __webpack_public_path__ + "img/ksh14.0e6b71d0.png";